export default __webpack_public_path__ + "static/media/trade.2e62e5b2.jpg";